<!--<br-page [configuration]="configuration" [mapping]="mapping">-->
<!--	<ng-template let-page="page">-->
<!--		<mflooring-single-column [page]="getPageTemplate(page)"></mflooring-single-column>-->
<!--	</ng-template>-->
<!--</br-page>-->
<!-- Global Overlay -->
@if (isOverlayVisible) {
  <div
    class="global-overlay"
  ></div>
}
<br-page
  [configuration]="configuration"
  [mapping]="mapping"
  (state)="setVisitor($event)"
  >
<ng-template let-page="page">
  <div class="single-page-container">
    <section class="meta">
      <ng-container brComponent="metadata"></ng-container>
    </section>
    <header>


      <nav class="navbar" role="navigation">
        <ng-container
          brComponent="header-navigation/header-container"
        ></ng-container>
      </nav>
    </header>
    <section class="main-body" [ngClass]="{'shopPage': shopPage, 'hardwood-landing': isHardwoodLanding}">
      <ng-container brComponent="drop-zone-1"></ng-container>
      <ng-container brComponent="drop-zone-2"></ng-container>
      @if (getPageTemplate(page) !== 'single-column') {
        <ng-container
          brComponent="form/{{ getPageTemplate(page) }}"
        ></ng-container>
      }

      <ng-container   brComponent="drop-zone-3"></ng-container>
      <ng-container *appLazyRender  brComponent="drop-zone-4"></ng-container>
    </section>

    <footer >
      <!-- *appLazyRender *ngIf="showBottomContent()"-->
      <ng-container *appLazyRender    brComponent="footer/footer-container"></ng-container>
    </footer>
  </div>
</ng-template>
</br-page>

